import "./BaseButton_module.css";
const BaseButton_module = {
    button: "button__6651906cf0cb206f",
    iconButton: "iconButton__6651906cf0cb206f",
    loadingIcon: "loadingIcon__6651906cf0cb206f",
    buttonAdornmentIcon: "buttonAdornmentIcon__6651906cf0cb206f"
};
export { BaseButton_module as default };
